<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "juoksuvoimaa_lihaskuntoharjoittelusta";
    let title = "Juoksuvoimaa lihaskuntoharjoittelusta";
    let author = "Mata";
    let blogDate = "6.8.2018";
    let titlePic = "2018/juoksutreenit.jpg";
    let firstPara = "Lihasten toimintakyky on kestävyyslajeissa oleellisessa roolissa ja vahva jaksaa pidemmälle. Voimaa tarvitaan niin eteenpäin vievään liikkeeseen kuin hyvän ryhdin ylläpitämiseen.";
</script>


<!--  muille sivuille tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->
{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>


<!--  varsinainen blogiteksti -->
{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}<br><small>- Sopivatko kestävyyslajit ja voimaharjoittelu yhteen?</small></h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            

<p>Kestävyysurheilua, kuten juoksu, hiihto - tai vaikkapa triathlon - ei usein mielletä voimalajeiksi.
Kuitenkin lihasten toimintakyky on kestävyyslajeissa oleellisessa roolissa ja vahva jaksaa pidemmälle.
Voimaa tarvitaan kaikkeen toimintaan - niin eteenpäin vievään liikkeeseen kuin hyvän ryhdin ylläpitämiseen.</p>

<p>Taloudellinen juoksuaskel tuottaa tehokkaasti eteenpäin vievää voimaa
mahdollisimman pienellä energiankulutuksella. Vahva pyöräilijä jaksaa jatkaa ylämäkeen kun heikommalla
loppuu reisistä potku, uimari tarvitsee voimaa ylävartaloon. Listaa voisi jatkaa loputtomiin.   </p>
            
<h4>Voimaharjoittelun tavoitteet kestävyysurheilijalla</h4>

<p>Miksi tavoitteellisesti harjoittelevan kuntoilijan tulisi tehdä voimatreeniä? Kaloreitahan siinä palaa vaikka juoksisi vähän epätaloudellisemmin?</p>

<p><strong>1. Hyvinvointi ja terveys.</strong> Ensinnäkin urheilija tarvitsee perusvoimaa ihan samasta syystä kuin kuka tahansa muukin elävä olento, oman hyvinvoinnin edistämiseen ja terveyden ylläpitämiseen. Esimerkiksi juoksu lajina ei ole riittävän monipuolista tuottaakseen kaikkia liikunnan terveyshyötyjä - lähtien hyvästä ryhdistä, liikkuvuudesta ja tuki- ja liikuntaelimistön hyvinvoinnista. Elämää on myös lenkkipolkujen ulkopuolella ja voimaharjoittelusta siirtyvät hyödyt arkielämään ovat kiistattomat.</p>

<p><strong>2. Lajinomaisen harjoittelun mielekkyys</strong>. Keskivartalon hallinta auttaa jaksamaan pitkällä lenkillä, ja voimakkaat jalat vievät askelta tehokkaammin eteenpäin. Vahvat lihakset eivät välttämättä tarkoita suuria lihaksia, sillä lihaskunto- ja voimaharjoittelun tarkoituksellisuus tulee esiin lihasten toiminnaan tehostumisena. Mitä pienemmällä "vaihteella" lihakset toimivat liikkuessa, sen vaivattomampaa liikkuminen on.</p>

<p><strong>3. Uusi ärsykkeitä elimistölle.</strong>Elimistö tottuu siihen treenimuotoon mitä se tekee jatkuvasti. Pitkään toteutettuna kestävyysharjoittelu hidastuttaa lihakset, eivätkä lihakset enää aktivoidu yhtä tehokkaasti. Vaihtelevalla lihaskuntotreenillä saadaan horjutettua tätä tasapainoa. Hermo-lihasjärjestelmä saa uudenlaisia ärsykkeitä ja juoksija piristyy.</p>

<p><strong>4. Vammojen välttäminen.</strong> Esimerkiksi juoksussa jalkojen nivelet ovat kovilla. Nivelet, luut ja lihakset vahvistuvat voimaharjoittelun myötä. Hyvin toteutettu salitreeni parantaa tukilihasten toimintaa niin, että nivelet toimivat oikein ja liikeradat pysyvät lähempänä optimaalista. Oikein toteutettuna salitreenillä voidaan myös parantaa rakenteellista epätasapainoa ja parantaa liikkuvuutta, mikä osaltaan ehkäisee nivelongelmia. Jos jokaisella askeleella saadaan edes hieman vähennettyä vaikkapa polveen kohdistuvaa kuormitusta, on sillä iso merkitys kun puhutaan tuhansista toistoista pelkästään yhden liikuntasuorituksenaikana.</p>

<p><strong>5. Hormonaliset hyödyt.</strong> Voimaharjoittelusta syntyy ikäänkuin sivutuotteena elimistöön rakentavia hormoneja, jotka nopeuttavat palautumista ja muutenkin vaikuttavat positiivisesti terveyteen, mm. tehostamalla rasvanpolttoa ja parantamalla unen laatuua.</p>

<h4>Lihaskuntoharjoittelu ja harjoittelun jaksottaminen</h4>

<p>Peruskuntoilijan harjoittelellessa on voima- ja kestävyysominaisuuksia mahdollista kehittää samanaikaisesti.
     Mitä kovemmalle tasolle mennään, sitä ongelmalliseksi ohjelmointi muodostuu, mikäli yritetään pitkään kehittää molempia ominaisuuksia. Niinpä urheilumaailmassa on pitkään puhuttu erilaisista harjoituskausista. Harjoituskausi alkaa ylimenokauden jälkeen yleensä peruskuntokaudella, jatkuen lajista riippuen erilaisilla painotuksilla kohti herkistely- ja kisakautta.</p>

<p>Myös tavanomainen kuntoilija hyötyy harjoittelun jaksottamisesta. Niinpä esimerkiksi Hilma Hiihtäjän ja 
    Jukka Juoksijan kannattaa aika-ajoin ottaa kalenteri käteen ja istahtaa miettimään treenejä vuositasolla. 
    Jaksotusta suunnitellessa on hyvä pohtia mitkä osa-alueet itsellä on heikoimmalla tolalla. Samalla kun 
    alkaa peruskunnon rakentaminen, on hyvää aikaa myös kehittää lihasten hermostollisia ominaisuuksia samalla 
    ja kenties keskittyä mahdollisten tekniikkavirheiden hiomiseen. Uudenlaisten harjoitusten ja vaihtelevuuden myötä
    saattaa myös treenimotivaatio lähteä uuteen nousuun.</p>

<p>Aiheena periodisointi on hyvin laaja ja sitä on mahdotonta täysin avata yhdessä tekstissä. Kunnollisen 
    harjoitusohjelman rakentaminen vaatii laajan tuntemuksen urheilijan varsinaisesta päälajista, kyseisen 
    urheilijan harjoittelutaustasta sekä voimaharjoittelun periaatteista.</p>

<p><img src="/svelte-site/img/blog/2018/askelkyykky.jpg" alt="askelkyykky levytangolla"></p>

<h2>Millainen on hyvä kestävyysurheilijan lihaskunto-ohjelma?</h2>

<p>Lihaskunto-ohjelmaa suunnitellessa täytyy huomioida se koko urheilijan elämäntilanne, jossa harjoitusohjelmaa 
    tullaan toteuttamaan.</p>

<p>Ainakin seuraavat asiat tulisi huomioida voimaohjelmaa suunnitellessa:</p>
    
<ul>
    <li>liikkuvuusongelmat ja niiden huomioiminen, erityisesti lajivaatimusten näkökulmasta</li>
    <li>aiempi harjoittelutausta, aiemmat loukkaantumiset ym. rajoittavat tekijät</li>
    <li>nykyiset vahvuudet ja heikkoudet suhteessa lajivaatimuksiin voimaominaisuuksien kannalta</li>
    <li>käytettävissä oleva aika, muiden harjoitusten ja elämäntilanteen aiheuttama kuormitus ja palautumiskapasiteetti</li>
    <li>muun harjoittelun periodisointi sekä raskaat ja kevyet viikot</li>
    <li>tasapainottaminen mahdollisilta lajin aiheuttamilta epätasaisilta kuormituksista 
        (puolierot, ylä/alavartalon kuormitus, etu/takaketju)</li>
    <li>yleiskunnon edistäminen niillä osa-alueilla jotka jäävät lajiharjoittelussa paitsioon</li>
</ul>

<p>Usein harjoittelussa tapahtuu virheitä siinä että mennään "semisti aika kovaa" - ei malteta palautella eikä 
    sitten myöskään riitä paukkuja mennä kovissa treeneissä oikeasti kovaa. Usein myös liikutaan siellä omalla 
    mukavuusalueella - vahvistetaan entisestään osa-alueita, jotka ovat jo valmiiksi vahvuuksia. On kuitenkin 
    muistettava, että urheilija on niin heikko kuin ketjun heikoin lenkki. Vaatii rohkeutta poiketa totutuista 
    treenimetodeista ja kokeilla uutta. Tarvittaessa ammattilaisen tai kokeneiden kanssatreenaajien näkökulma 
    auttaa priorisoimaan harjoitusohjelmaan mukaan ne oleellisimmat, itselle tärkeimmät harjoitteet.</p>

<p>- Mata</p>



        </article>




        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='muscle_up_renkaissa' title='Muscle up renkaissa' titlePic='2018/muscleup_strip.jpg' blogDate='' firstPara='Muscle up, jota myös voimavedoksi sanotaan, on liike jossa urheilija punnertaa itsensä roikkumisasennosta renkaiden päälle rengaspitoon. Tässä artikkelissa käymme läpi muutamia vinkkejä liikkeen opettelemiseksi.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='6-syyta-tehda-nopeusvoimaharjoittelua' title='6 syytä tehdä nopeusvoimaharjoittelua' titlePic='nopeusharjoittelu.jpg' blogDate='' firstPara='Lihasten tuottama voima voidaan lajitella käytännössä kolmeen luokkaan. Kaiken kivijalka on kestovoima, jonka päälle rakennetaan maksimi- ja nopeusvoima.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='nuts-karhunkierros-2019-83km' title='Ensikertalaisena NUTS Karhunkierroksella' titlePic='karhunkierros.jpg' blogDate='' firstPara='Kaikki alkoi jostain tyhmästä ideasta, joka alkoi pikkuhiljaa paisua. Lähteä nyt juoksemaan Karhunkierros, oletko ikinä kokeillut vaeltaa sitä, no en ole. Ja nyt se oli edessä. 83 km, hirvitti.'></BlogSummary>
                </article>
            </div>
        </section>



    </div>
{/if}

<style>


</style>